import { ColumnDef } from "@tanstack/react-table";
import { StudentsFilter } from "../../../api/client";

export interface DataTableProps<TData, TValue> {
  columns: ColumnDef<TData, TValue>[];
}

export interface SearchableField {
  id: string;
  label: string;
  category?: string;
}

export const searchableFields: { category: string; fields: SearchableField[] }[] = [
  {
    category: 'Text',
    fields: [
      { id: 'name', label: 'Name' },
      { id: 'major', label: 'Major' },
      { id: 'usfid', label: 'usfid' },
      { id: 'netID', label: 'Net ID' },
      { id: 'studentType', label: 'Student Type' },
      { id: 'campus', label: 'Campus' },
      { id: 'admissionScholarships', label: 'Admission Scholarships' },
      { id: 'professionalInterest', label: 'Professional Interest' },
      { id: 'personalInterest', label: 'Personal Interest' },
      { id: 'languagesSpoken', label: 'Languages Spoken' },
      { id: 'languagesStudied', label: 'Languages Studied' },
    ]
  },
  {
    category: 'Number',
    fields: [
      { id: 'minimumGPA', label: 'GPA' },
      { id: 'minimumSemestersCompleted', label: 'Semesters Completed' },
    ]
  },
  {
    category: 'Date',
    fields: [

      { id: 'expectedGraduationAfter', label: 'Expected Graduation' },
    ]
  },

  {
    category: 'Boolean',
    fields: [
      { id: 'interestInGraduateSchool', label: 'Interest In Graduate School', category: 'Boolean' },
      { id: 'interestInGraduateSchoolAbroad', label: 'Interest In Graduate School Abroad', category: 'Boolean' },
      { id: 'hasGraduated', label: 'Has Graduated', category: 'Boolean' },
      { id: 'isUndergraduateStudent', label: 'Is Undergraduate Student', category: 'Boolean' },
      { id: 'isInterestedInResearch', label: 'Is Interested In Research', category: 'Boolean' },
      { id: 'isInvolvedInResearch', label: 'Is Involved In Research', category: 'Boolean' },
      { id: 'hasStudiedAbroad', label: 'Has Studied Abroad', category: 'Boolean' },
      { id: 'interestInStudyAbroad', label: 'Interest In Study Abroad', category: 'Boolean' },
    ]
  },
];

export const defaultFilter = new StudentsFilter({
  name: "",
  major: "",
  usfid: "",
  netID: "",
  studentType: [],
  campus: undefined,
  admissionScholarships: [],
  professionalInterest: [],
  personalInterest: [],
  languagesSpoken: [],
  languagesStudied: [],
  minimumGPA: undefined,
  minimumSemestersCompleted: undefined,
  lastLoginAfter: undefined,
  expectedGraduationAfter: [],
  interestInGraduateSchool: undefined,
  interestInGraduateSchoolAbroad: undefined,
  hasGraduated: undefined,
  isUndergraduateStudent: undefined,
  isInterestedInResearch: undefined,
  isInvolvedInResearch: undefined,
  hasStudiedAbroad: undefined,
  interestInStudyAbroad: undefined
});
